import React from 'react';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { PositionsDetails } from './components/PositionsDetails/PositionsDetails';
import { HtmlTable } from '../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';

interface Props {
  positionName: string;
  onRequestClose(): void;
}

export const PositionsModal: React.FC<Props> = ({ positionName, onRequestClose }) => {
  return (
    <Modal isOpen size="xl" onRequestClose={onRequestClose}>
      <ModalHeader>{`${positionName} Unrealized Lot Details`}</ModalHeader>
      <ModalCloseButton onClick={onRequestClose} />

      <HtmlTable
        variant="embedded"
        columnSpacing="small"
        fixedHead
        minHeight={400}
        maxHeight="80vh"
      >
        <table>
          <thead>
            <tr>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Purchase Date
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Units
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Price
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Cost/Share
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Market Value
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Cost Basis
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Unrealized G/L
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="left">
                  Holding Period
                </Text>
              </th>
            </tr>
          </thead>

          <PositionsDetails positionName={positionName} />
        </table>
      </HtmlTable>
    </Modal>
  );
};
